module.exports = __webpack_public_path__ + "static/video8-39907dd572db9a760005609c72816c08.mp4";